<!-- <body class="inventory-body">
    <div class="login-container">
        <div class="login-logo">
            <img src="./assets/Amrize_h_rgb.png" />
        </div>
        <h3 class="bg-title">Welcome!</h3>
        <asl-google-signin-button type='standard' size='large' shape='pill'></asl-google-signin-button>
    </div>
</body> -->

<div class="li-page d-flex">
    <div class="vic li-left-content">
      <div class="rab app-logo-name">
        <!-- <img src="assets/images/holcim-logo.png" alt="Holcim logo"/>
        <p class="cp-str">Hint</p> -->
      </div>
    </div>
    <div class="vic li-right-content">
      <p class="gs-str">Welcome to Amrize Shared Drive App</p>
      <div class="hic">
        <div id="google-button">
          <asl-google-signin-button type='standard' size='large' shape='pill'></asl-google-signin-button>
        </div>
      </div>
      <p class="liratp-str">
        Sign in with Google
      </p>
      <div class="hic">
        <img  src="../../assets/Amrize_tagline_h_rgb.svg" alt="logo" style="width: 150px;"/>
      </div>
      <!-- <div class="hic">
        <p class="tou-str">Terms of use</p>
        <p class="pp-str">Privacy policy</p>
      </div> -->
    </div>
  </div>
  